import { call, select, takeEvery } from 'redux-saga/effects';

import { saveDraftPerSection, resource, getError } from 'modules/api';

import {
  bookIdSelector,
  draftIdSelector,
  draftNameSelector,
  coverSectionSelector,
} from 'modules/editor/store';
import { SAVE_COVER } from 'modules/editor/store/constants';

export function* onSaveCover() {
  try {
    const bookId = yield select(bookIdSelector);
    const draftId = yield select(draftIdSelector);
    const draftName = yield select(draftNameSelector);
    const section = yield select(coverSectionSelector);

    const request = resource(SAVE_COVER, saveDraftPerSection);
    yield call(request, {
      bookId,
      draftId,
      draftName,
      section,
    });

    return true;
  } catch (error) {
    const payload = getError(error);
    // eslint-disable-next-line no-console
    console.error(payload);

    return false;
  }
}

export function* watchSaveCover() {
  yield takeEvery(SAVE_COVER, onSaveCover);
}
